export enum MESSAGE_TYPE {
    Bot,
    User,
    TimeStamp,
    Agent
}